/*
 * Page metadata
 */

import { Helmet } from 'react-helmet-async';
import PropTypes from 'prop-types';
import React from 'react';
import StripTags from 'striptags';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @component Meta
 * @props (see propTypes)
 */
const Meta = (props) => {
    const page = props.page || {};

    // Meta
    const description   = props.description || page.searchDescription || page.standfirst || page.description || '';
    const image         = props.image || page.metaImage || page.listingImage || page.heroImage;
    const keywords      = props.keywords || page.metaKeywords;
    const title         = props.title || page.seoTitle || page.title || 'Public Practice';
    const url           = props.url ? `${props.domain}/${props.url}` : props.domain;
    const twitterHandle = null;

    return (
        <Helmet>
            <meta
                content='Public Practice'
                name='site_name' />
            {title && <title>
                {title}
            </title>}
            {description && <meta
                content={StripTags(description)}
                name='description' />}
            {keywords && <meta
                content={keywords}
                name='keywords' />}
            {description && <meta
                content={StripTags(description)}
                property='og:description' />}
            <meta
                content={image ? image.src : `${props.domain}/images/social.jpg`}
                property='og:image' />
            {title && <meta
                content={title}
                property='og:title' />}
            {url && <meta
                content={url}
                property='og:url' />}
            <meta
                content='website'
                property='og:type' />
            <meta
                content='summary_large_image'
                name='twitter:card' />
            {twitterHandle && <meta
                content={twitterHandle}
                name='twitter:creator' />}
            {description && <meta
                content={StripTags(description)}
                name='twitter:description' />}
            <meta
                content={image ? image.src : `${props.domain}/images/social.jpg`}
                property='twitter:image:src' />
            {title && <meta
                content={title}
                property='twitter:title' />}
        </Helmet>
    );

};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

Meta.propTypes = {
    description: PropTypes.string,
    domain     : PropTypes.string,
    image      : PropTypes.object,
    keywords   : PropTypes.string,
    page       : PropTypes.object,
    title      : PropTypes.string,
    url        : PropTypes.string
};

export default Meta;
